/* 
    需要使用标签跳转小程序  username 是小程序原始id  path 是进入小程序的目标页面+参数字符串
    <div :username="username" :path="path" v-wx-weapp></div>
    需要使用标签跳转app appid 是app的原始id  extinfo 是进入app后传递给app的参数
    <div :appid="appid" :extinfo="extinfo" v-wx-weapp></div>
*/
import composition from '@/composition'
const { openApp } = composition()

function MyDirective(app) {
  // 打开小程序
  app.directive('wx-weapp', {
    // 当被绑定的元素挂载到 DOM 中时……
    mounted(targetEl) {
      if (!targetEl.style.position) {
        targetEl.style.position = 'relative'
      }
      let username = targetEl.attributes.username.nodeValue
      let path = targetEl.attributes.path.nodeValue
      let version = targetEl.attributes.version ? targetEl.attributes.version.nodeValue : 'release'
      let div = document.createElement('div')
      div.id = 'launch-wxapp'
      div.style.position = 'absolute'
      div.style.top = '0'
      div.style.bottom = '0'
      div.style.left = '0'
      div.style.right = '0'
      div.style.zIndex = '1600'
      div.style.overflow = 'hidden'
      div.style.background = 'transparent'
      div.innerHTML = `
        <wx-open-launch-weapp username="${username}" path="${path}" env-version="${version}">
          <template>
            <div style="background: transparent; padding:5000px"></div> 
          </template>
        </wx-open-launch-weapp>
      `
      targetEl.appendChild(div)
    },
    // 当被绑定的元素挂载到 DOM 中时……
    updated(targetEl) {
      if (!targetEl.style.position) {
        targetEl.style.position = 'relative'
      }
      let username = targetEl.attributes.username.nodeValue
      let path = targetEl.attributes.path.nodeValue
      let version = targetEl.attributes.version ? targetEl.attributes.version.nodeValue : 'release'
      try {
        let old_btn = targetEl.querySelector('#launch-wxapp')
        old_btn.remove()
      } catch (error) {
        console.log(error)
      }
      let div = document.createElement('div')
      div.id = 'launch-wxapp'
      div.style.position = 'absolute'
      div.style.top = '0'
      div.style.bottom = '0'
      div.style.left = '0'
      div.style.right = '0'
      div.style.zIndex = '1600'
      div.style.overflow = 'hidden'
      div.style.background = 'transparent'
      div.innerHTML = `
        <wx-open-launch-weapp username="${username}" path="${path}" env-version="${version}">
          <template>
            <div style="background: transparent; padding:5000px"></div> 
          </template>
        </wx-open-launch-weapp>
      `
      targetEl.appendChild(div)
    }
  })
  // 打开app
  app.directive('wx-app', {
    mounted(targetEl) {
      let elId = targetEl.attributes.elId ? targetEl.attributes.elId.nodeValue : 'launch-app'
      let appid = targetEl.attributes.appid ? targetEl.attributes.appid.nodeValue : ''
      let extInfo = targetEl.attributes.extInfo ? targetEl.attributes.extInfo.nodeValue : ''

      let div = document.createElement('div')
      div.id = `${elId}Container`
      div.style.position = 'absolute'
      div.style.top = '0'
      div.style.bottom = '0'
      div.style.left = '0'
      div.style.right = '0'
      div.style.zIndex = '1600'
      div.style.overflow = 'hidden'
      div.style.background = 'transparent'
      div.innerHTML = `
          <wx-open-launch-app id="${elId}" appid="${appid}" extinfo="${extInfo}">
            <template><button style="width:${targetEl.offsetWidth}px;height:${targetEl.offsetHeight}px;padding:20px;overflow:hidden;opacity:0;">App内查看</button></template>
          </wx-open-launch-app>
        `
      targetEl.appendChild(div)
      let btn = document.getElementById(elId)
      btn.addEventListener('launch', function (e) {
        console.log('success', e.detail)
      })
      btn.addEventListener('error', function (e) {
        console.log('fail', e.detail)
        openApp()
      })
    },
    updated(targetEl) {
      let elId = targetEl.attributes.elId ? targetEl.attributes.elId.nodeValue : 'launch-app'
      let appid = targetEl.attributes.appid ? targetEl.attributes.appid.nodeValue : ''
      let extInfo = targetEl.attributes.extInfo ? targetEl.attributes.extInfo.nodeValue : ''

      try {
        let old_btn = targetEl.querySelector(`#${elId}Container`)
        old_btn && old_btn.remove()
      } catch (error) {
        console.log(error)
      }

      let div = document.createElement('div')
      div.id = `${elId}Container`
      div.style.position = 'absolute'
      div.style.top = '0'
      div.style.bottom = '0'
      div.style.left = '0'
      div.style.right = '0'
      div.style.zIndex = '1600'
      div.style.overflow = 'hidden'
      div.style.background = 'transparent'
      div.innerHTML = `
          <wx-open-launch-app id="${elId}" appid="${appid}" extinfo="${extInfo}">
            <template><button style="width:${targetEl.offsetWidth}px;height:${targetEl.offsetHeight}px;padding:20px;overflow:hidden;opacity:0;">App内查看</button></template>
          </wx-open-launch-app>
        `
      targetEl.appendChild(div)
      let btn = document.getElementById(elId)
      btn.addEventListener('launch', function (e) {
        console.log('success', e.detail)
      })
      btn.addEventListener('error', function (e) {
        console.log('fail', e.detail)
        openApp()
      })
    }
  })
}

export default {
  install(app) {
    MyDirective(app)
  }
}
